import { render, staticRenderFns } from "./EnConstruccion.vue?vue&type=template&id=31aeadc7&"
import script from "./EnConstruccion.vue?vue&type=script&lang=js&"
export * from "./EnConstruccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports